import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addTimeoutSetting = (timeout) => {
  return axios.post(API + "company/company-settings/", {
    timeout
  },{headers: authHeader(),});
};

const getTimeoutSetting = async() =>{
  return await axios.get(API + "company/companysettingsview/",{
    headers: authHeader(),
  });
}
const AddTimeoutSettingService = {
    addTimeoutSetting,
    getTimeoutSetting
  };
  export default AddTimeoutSettingService;